// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../setISODay/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var setISODay = convertToFP(fn, 2);
export default setISODay;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/setISODay/index.js
// module id = 973
// module chunks = 0